var map = {
	"./howto-gift.json": "UuMo",
	"./howto-message.json": "QVZD",
	"./howto-share.json": "932Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iSGt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/json ^\.\/howto\-.*\.json$
// module id = iSGt
// module chunks = 1